import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import classnames from 'classnames';
import { CardText, UncontrolledTooltip } from 'reactstrap';
import {
  Circle,
  CheckCircle,
  ArrowLeft,
  Clock,
  XCircle,
  MessageCircle,
  Edit2,
} from 'react-feather';

import AppCollapse from '@core/components/app-collapse';
import { useCourse, useUnit } from 'hooks/units/index';
import { getIconFromType } from 'helpers/index';
import { getUnitRoute } from 'helpers/unitRoute';
import {
  LIMIT_DETAILPAGE_LIST,
  STATUS_FILES_UNIT,
  UNIT_STATUS,
  UNIT_STATUS_TOOL_TIP,
  UNIT_TYPE,
  USER_ROLES,
} from 'constants/constants';

import styles from 'styles/Unit.module.scss';
import Link from 'next/link';
import {
  formatDDMMYYYYHHMM,
  titleExtensionWithTimeZone,
} from 'helpers/format-time';
import { useSelector, useDispatch } from 'react-redux';
import { getDetailPageCurrentTab, setDetailPageCurrentTab } from 'store/global';
import userGroupApi from 'api/userGroupApi';
import { getSelectedCentre } from 'store/master';
import { getViewMode } from 'store/auth';
import { InView } from 'react-intersection-observer';
import { getIsUnitLoading, getUnit, setUnitLoading } from 'store/units';
import { getThemeColor } from 'store/settings';
import {
  accessDenied,
  handleLessonAccess,
} from 'modules/Course/CourseDetail/optimizedDetailPage/lesson-access-modal';
import ReactDOMServer from 'react-dom/server';
import moment from 'moment';
import { BiCircle } from 'react-icons/bi';

const componentIconCompleted = {
  COMPLETED: <BiCircle size={20} style={{ color: '#28c76f' }} />,
  GRADED: <BiCircle size={20} style={{ color: '#28c76f' }} />,
  'In-Progress': <BiCircle size={20} style={{ color: '#E59819' }} />,
  REATTEMPT: <BiCircle size={20} style={{ color: '#E59819', marginTop: -3 }} />,
  FAILED: <BiCircle size={20} style={{ color: '#FC3434' }} />,
  PENDING: <BiCircle size={20} style={{ color: '#E59819' }} />,
  REVIEW: <BiCircle size={20} style={{ color: 'rgb(0 115 239)' }} />,
  INCOMPLETED: <BiCircle size={20} style={{ color: '#FC3434' }} />,
};

const CourseInfo = () => {
  const themeStatus = useSelector(getThemeColor);
  const unitSelected = useUnit();
  const [unitObject, setUnitObject] = useState({
    data: [],
    currentPage: 1,
  });
  const unit = useSelector(getUnit);
  const router = useRouter();
  const getUnitLoading = useSelector(getIsUnitLoading);
  const selectedCentre = useSelector(getSelectedCentre);
  const viewMode = useSelector(getViewMode);
  const course = useCourse();
  const dispatch = useDispatch();
  const tabValues = useSelector(getDetailPageCurrentTab);
  const metaData = useSelector((state) => state.settingAccount.metaData);
  const { query, push } = router;
  const discussionTab = () => {
    let array = [...tabValues];
    array.push({ id: query?.slug, tab: 5 });
    dispatch(setDetailPageCurrentTab(array));
    push(`/course/${course?._id}`);
  };
  const nth = (getdate) => {
    if (getdate > 3 && getdate < 21) return 'th';
    switch (getdate % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  const formatHandler = (time, title, courseInfo) => {
    const timeStart = new Date(time?.begin);
    const timeEnd = new Date(time?.end);
    var time_Start = dateConversion(timeStart);
    var time_End = dateConversion(timeEnd);
    let data = `${title} (${courseInfo.code})  ${time_Start.nameOfDay} ${time_Start.getdate}${time_Start.nth} ${time_Start.month} ${time_Start.strTime} - ${time_End.strTime}`;
    return data;
  };

  useEffect(async () => {
    const params = {
      ...((selectedCentre?.reviewContent || selectedCentre === undefined) && {
        reviewContent: true,
      }),
      page: 1,
      rowPerPage: LIMIT_DETAILPAGE_LIST,
      ...(selectedCentre?._id && { courseCentre: selectedCentre?._id }),
    };
    const res = await userGroupApi.getAllLessonByIntake(query?.slug, params);

    setUnitObject(res);
    return () => dispatch(setUnitLoading(false));
  }, [query?.slug, unit]);

  // useEffect(() => {
  //   if (Object.keys(unit).length) {
  //     const newArray = [...unitObject.data];
  //     const index = newArray.findIndex((unitObj) => unitObj?._id === unit?._id);
  //     if (index !== -1 && newArray[index]?.unitStatus !== unit?.status) {
  //       newArray[index] = {
  //         ...newArray[index],
  //         unitStatus: unit.status,
  //       };
  //       setUnitObject((preVal) => ({ ...preVal, data: newArray }));
  //     }
  //   }
  //   console.log({ unit });
  // }, [unit]);

  const handleLoading = async (inView) => {
    if (inView) {
      const params = {
        ...((selectedCentre?.reviewContent || selectedCentre === undefined) && {
          reviewContent: true,
        }),
        ...(selectedCentre?._id && { courseCentre: selectedCentre?._id }),
        page: unitObject.currentPage + 1,
        rowPerPage: LIMIT_DETAILPAGE_LIST,
      };
      const res = await userGroupApi.getAllLessonByIntake(query?.slug, params);
      setUnitObject((preVal) => ({
        ...res,
        data: [...preVal?.data, ...res?.data],
      }));
    }
    getUnitLoading && dispatch(setUnitLoading(false));
  };
  const dateConversion = (startdate) => {
    var date_time = new Date(startdate);
    let dayOfWeekNumber = date_time.getDay();
    let getdate = date_time.getDate();
    let nameOfDay;
    var month = date_time.toLocaleString('default', { month: 'long' });

    switch (dayOfWeekNumber) {
      case 0:
        nameOfDay = 'Sunday';

        break;
      case 1:
        nameOfDay = 'Monday';

        break;
      case 2:
        nameOfDay = 'Tuesday';

        break;
      case 3:
        nameOfDay = 'Wednesday';

        break;
      case 4:
        nameOfDay = 'Thursday';

        break;
      case 5:
        nameOfDay = 'Friday';

        break;
      case 6:
        nameOfDay = 'Saturday';

        break;
    }

    var hours = date_time.getHours();
    var minutes = date_time.getMinutes();
    var ampm = hours < 12 ? 'AM' : 'PM';
    hours = hours % 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    var strTime = `${hours}:${minutes}${ampm}`;
    let date_conversation = {
      nameOfDay: nameOfDay,
      getdate: getdate,
      nth: nth(getdate),
      month: month,
      strTime: strTime,
    };

    return date_conversation;
  };

  const handleScheduleMeet = (time, type) => {
    accessDenied(
      `This lesson will be accessible at the scheduled time. <br />
           Start Date: <strong> ${formatDDMMYYYYHHMM(time?.begin)} </strong> ${
        time?.due && type !== UNIT_TYPE.LIVESTREAMING
          ? `| Due Date: <strong> ${formatDDMMYYYYHHMM(time?.due)} </strong>`
          : ''
      }   | End Date: <strong>  ${formatDDMMYYYYHHMM(time?.end)} </strong> `,
      {
        confirmButtonColor: themeStatus,
      },
    );
  };

  const renderTextContent = (
    {
      title,
      status,
      unit,
      _id,
      canLearn,
      isLiving,
      time,
      timezone,
      courseInfo,
      importLesson,
      unitStatus,
      titleExtenstion,
      isUnitAccess,
      mainType,
      preRequisiteAccess,
      preRequisiteLessons,
      statusFile,
      isCombinedClassParent,
      isCombinedClass,
      isCompleted,
      config,
      result,
      restrictAccess,
      userQuestions,
    },
    lastChild,
  ) => (
    <InView
      rootMargin="0% 0% 90% 0%"
      triggerOnce={true}
      threshold={1}
      onChange={handleLoading}
      key={_id.concat(unitStatus)}
      as="div"
    >
      {({ ref }) => (
        <div
          className={classnames(
            styles.wrapperTextContent,
            unitSelected?._id === (unit ?? _id) && styles.unitSelected,
          )}
          ref={lastChild ? ref : null}
          key={_id.concat(unitStatus)}
        >
          <div
            className={classnames(
              styles.wrapperStatus,
              status !== UNIT_STATUS.COMPLETED && styles.noComplete,
            )}
            style={{
              minWidth: 58.5,
            }}
          >
            <>
              {!unitStatus ||
              (unitStatus === UNIT_STATUS.RESUBMIT && !result) ||
              unitStatus === UNIT_STATUS.NOSTARTED ||
              unitStatus === UNIT_STATUS.RESET ||
              (unitStatus === 'IN_PROGRESS' && !result) ? (
                <Circle
                  size={20}
                  id={`icon_status_${_id}`}
                  style={{
                    stroke:
                      status === 'ACTIVE' || status === 'INACTIVE'
                        ? 'var(--course-unit-status-icon-clr)'
                        : 'var(--course-unit-disabled-text-clr)',
                  }}
                />
              ) : (
                <span id={`icon_status_${_id}`}>
                  {
                    componentIconCompleted[
                      (config?.manualMarking?.status ||
                        userQuestions?.length) &&
                      unitStatus == UNIT_STATUS.INPROGRESS &&
                      isCompleted
                        ? UNIT_STATUS.REVIEW
                        : [UNIT_STATUS.RESET, UNIT_STATUS.RESUBMIT].includes(
                            unitStatus,
                          ) && result
                        ? UNIT_STATUS.INPROGRESS
                        : unitStatus
                    ]
                  }
                </span>
              )}

              <UncontrolledTooltip
                placement="right"
                target={`icon_status_${_id}`}
              >
                {
                  UNIT_STATUS_TOOL_TIP[
                    (config?.manualMarking?.status || userQuestions?.length) &&
                    unitStatus == UNIT_STATUS.INPROGRESS &&
                    isCompleted
                      ? UNIT_STATUS.REVIEW
                      : [UNIT_STATUS.RESET, UNIT_STATUS.RESUBMIT].includes(
                          unitStatus,
                        ) && result
                      ? UNIT_STATUS.INPROGRESS
                      : unitStatus
                  ]
                }
                {/* 
        
                {/* {unitStatus[0].toUpperCase() +
                  unitStatus.slice(1).toLowerCase()} */}
              </UncontrolledTooltip>
            </>

            <span
              className="ml-25"
              id={`icon_discussion_${_id}`}
              onClick={() => discussionTab()}
            >
              <MessageCircle
                className="text-secondary px-15 py-15 cursor-pointer"
                size={24}
                style={{
                  stroke:
                    status === 'ACTIVE' || status === 'INACTIVE'
                      ? '#347FF1'
                      : 'var(--course-unit-disabled-text-clr)',
                }}
              />
              <UncontrolledTooltip
                placement="right"
                target={`icon_discussion_${_id}`}
              >
                View discussions
              </UncontrolledTooltip>
            </span>
          </div>
          {typeof canLearn === 'boolean' && !canLearn ? (
            <CardText className="flexRow align-items-center justify-content-between flex-1">
              <div className={classnames(styles.textContent)}>
                <span
                  style={{
                    color: `${
                      status === 'ACTIVE' || status === 'INACTIVE'
                        ? ''
                        : 'var(--course-unit-disabled-text-clr)'
                    }`,
                  }}
                >
                  {getIconFromType(
                    isCombinedClass == true
                      ? UNIT_TYPE.COMBINE_CLASS
                      : mainType,
                    isLiving,
                  )}
                </span>
                <span
                  className={classnames(
                    `${
                      status === 'ACTIVE' || status === 'INACTIVE'
                        ? 'text__limit_line_2'
                        : 'text__limit_line_2-dective'
                    }`,
                  )}
                >
                  {mainType == UNIT_TYPE.LIVESTREAMING && titleExtenstion
                    ? title +
                      ' ' +
                      titleExtensionWithTimeZone(
                        time?.begin,
                        time?.end,
                        timezone,
                      )
                    : mainType == UNIT_TYPE.LIVESTREAMING &&
                      importLesson === true
                    ? formatHandler(time, title, courseInfo)
                    : title}
                </span>
              </div>
            </CardText>
          ) : (
            <CardText className="flexRow align-items-center justify-content-between flex-1">
              <div
                //aria-disabled={status === USER_STATUS.INACTIVE}
                className={classnames(
                  styles.textContent,
                  (metaData?.cmsHomePage ? isUnitAccess : true)
                    ? styles.textCanLearn
                    : null,
                  'flex-1',
                )}
                onClick={() => {
                  if (
                    typeof preRequisiteAccess == 'boolean' &&
                    !preRequisiteAccess
                  ) {
                    let lessonNames = '';
                    for (const element of preRequisiteLessons) {
                      const iconHTML = ReactDOMServer.renderToString(
                        getIconFromType(element?.type, element?.isLiving),
                      );
                      lessonNames += `<li class="text-truncate" style="padding: 5px 7px;margin: 5px 0px;font-size:14px; background-color: var(--course-unit-pill-bg-clr); color: var(--course-unit-content-text-clr);" title="${element.title}">${iconHTML}&nbsp;&nbsp;${element.title}</li>`;
                    }
                    handleLessonAccess(lessonNames, {
                      confirmButtonText: 'Okay',
                      confirmButtonColor: themeStatus,
                      cancelButtonColor: 'secondary',
                      showCancelButton: false,
                      focusConfirm: true,
                    });
                    return;
                  }
                  const isAssignment =
                    mainType === UNIT_TYPE.ASSIGNMENT &&
                    statusFile === STATUS_FILES_UNIT.UPCOMING;

                  const startDate = moment(time?.begin);
                  const now = moment();

                  const IsBefore = now.isBefore(startDate);

                  if (
                    mainType == UNIT_TYPE.LIVESTREAMING ? restrictAccess : true
                  ) {
                    if (
                      (mainType == UNIT_TYPE.LIVESTREAMING
                        ? !isLiving
                        : true) &&
                      viewMode === USER_ROLES.LEARNER &&
                      (isAssignment || IsBefore)
                    ) {
                      handleScheduleMeet(time, mainType);
                      return null;
                    }
                  }

                  if (status === 'ACTIVE' || status === 'INACTIVE') {
                    // if (metaData?.cmsHomePage ? isUnitAccess : true) {
                    sessionStorage.removeItem('shuffledArrayQuiz');

                    dispatch(setUnitLoading(true));
                    router.push(
                      getUnitRoute(query?.slug, {
                        unit,
                        _id,
                        type: mainType,
                        mainType,
                      }),
                    );
                    // }
                  }
                }}
              >
                <span
                  style={{
                    color: `${
                      status === 'ACTIVE' || status === 'INACTIVE'
                        ? ''
                        : 'var(--course-unit-disabled-text-clr)'
                    }`,
                  }}
                >
                  {getIconFromType(
                    isCombinedClass == true
                      ? UNIT_TYPE.COMBINE_CLASS
                      : mainType,
                    isLiving,
                  )}
                </span>
                <span
                  className={classnames(
                    `content-page-name ${
                      status === 'ACTIVE' || status === 'INACTIVE'
                        ? 'text__limit_line_2'
                        : 'text__limit_line_2-dective'
                    }`,
                  )}
                >
                  {mainType == UNIT_TYPE.LIVESTREAMING && titleExtenstion
                    ? title +
                      ' ' +
                      titleExtensionWithTimeZone(time?.begin, time?.end)
                    : mainType == UNIT_TYPE.LIVESTREAMING &&
                      importLesson === true
                    ? formatHandler(time, title, courseInfo)
                    : title}
                </span>
              </div>
            </CardText>
          )}
        </div>
      )}
    </InView>
  );

  const renderContent = () => {
    if (!unitObject.data) return [];

    let indexSections = unitObject.data.reduce((total, unit, index) => {
      if (unit.mainType === UNIT_TYPE.SECTION) {
        return [...total, index];
      }
      return total;
    }, []);
    if (unitObject.data[0]?.mainType !== UNIT_TYPE.SECTION) {
      indexSections = [0, ...indexSections];
    }

    const unitsFormat = indexSections.reduce((total, indexSection, index) => {
      if (index !== indexSections.length - 1) {
        const unitSlice =
          indexSection + 1 === indexSections[index + 1]
            ? [unitObject.data[indexSection]]
            : unitObject.data.slice(indexSection, indexSections[index + 1]);

        return [...total, [...unitSlice]];
      }

      const unitSlice = unitObject.data.slice(indexSection);
      return [...total, [...unitSlice]];
    }, []);
    return unitsFormat.map((units, index) => {
      if (unitObject.data?.length) {
        if (unitObject.data[0].mainType !== UNIT_TYPE.SECTION) {
          return (
            <div key={index}>
              {unitObject.data.map(
                (unit, index, currentArray) =>
                  unit?.mainType !== 'SUB_SECTION' &&
                  renderTextContent(unit, index === currentArray.length - 1),
              )}
            </div>
          );
        }

        // if (units.length === 1 && units[0].mainType === UNIT_TYPE.SECTION) {
        //   return (
        //     <div key={index} className={styles.containerOnlyTitleSection}>
        //       <h5>{units[0].title}</h5>
        //     </div>
        //   );
        // }

        return (
          <AppCollapse
            key={index}
            accordion
            active={0}
            data={[
              {
                title: units[0].title,
                content: (
                  <>
                    {units.map((unit, index) => {
                      if (index === 0) return;
                      return (
                        unit?.mainType !== 'SUB_SECTION' &&
                        renderTextContent(unit)
                      );
                    })}
                  </>
                ),
              },
            ]}
            titleClassName={styles.containerTitleSection}
          />
        );
      }
    });
  };

  return (
    <div className={styles.sticky_top}>
      <div className={classnames('fixCardBody', styles.containerCourse)}>
        <div className={`${styles.containerTitle}`}>
          <Link href={`/course/${course._id}`}>
            <h5
              className={`view-page-title ${styles.titleCourse}`}
              style={{ textAlign: 'left', marginLeft: '20px' }}
            >
              {course?.name || '...'}
            </h5>
          </Link>
          <ArrowLeft
            style={{ color: '#8E96AA' }}
            id="backCourse"
            className="cursor-pointer view-page-rightSide-color fontSize-14"
            onClick={() => router.push(`/course/${query?.slug}`)}
          />
          <UncontrolledTooltip placement="bottom" target="backCourse">
            Back to courses
          </UncontrolledTooltip>
        </div>
        <div>{renderContent()}</div>
      </div>
    </div>
  );
};

export default CourseInfo;
